import { lazy } from 'react';
// ----------------------------------------------------------------------

const PatientByTypePage = lazy(() => import('../pages/patientByType.page'));

// ----------------------------------------------------------------------

const PatientByTypeRoutes = [
    {
        path: 'sales',
        children: [
            { element: <PatientByTypePage />, layout: 'default', isAuthReq: true, index: true },
            // {
            //     path: 'add-patient',
            //     element: <addPatientPage />,
            //     layout: 'default',
            //     isAuthReq: true,
            // },
        ],
    },
];

export { PatientByTypeRoutes };
